import { render, staticRenderFns } from "./SearchClaimPayment.vue?vue&type=template&id=63593161&"
import script from "./SearchClaimPayment.vue?vue&type=script&lang=js&"
export * from "./SearchClaimPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports